








import { routes } from '@/config/app.config'

export default {
    data() {
        return {
            activeIndex: '0',
            routes,
        }
    },
    methods: {
        handleSelect(key: string, keyPath: string) {
            // this.$router.push(keyPath)
            // this.activeIndex = key
        },
    },
    name: 'Navigation',
}
